import api from "@utils/http";

/**
 * 获取我关注的老师列表
 * @param {}
 */
export const apiMyTeacher = p => api.post("my/queryMyTeacher", p);
/**
 * 获取我购买或授权的课程
 * @param {}
 */
export const apiMyCourse = p => api.post("my/queryMyCourse", p);
/**
 * 获取我收藏的课程
 * @param {}
 */
export const apiMyCollect = p => api.post("my/querycollectCourse", p);
/**
 * 获取Vip价格列表
 * @param {}
 */
export const apiVipList = p => api.post("vip/queryVipList", p);
/**
 * 获取Vip价格列表
 * @param {}
 */
export const getIntegralUseBuyVip = p => api.post("integral/getIntegralUseBuyVip", p);
/**
 * 购买 vip项
 * @param {}
 */
export const getStudentVipInfo = p => api.post("vip/getStudentVipInfo", p);
/**
 * 我的 - 我的VIP信息
 * @param {}
 */
export const apiBuyVip = p => api.post("vip/buyVip", p);
/**
 *  查询积分
 * @param {}
 */
export const apiMyIntegral = p => api.post("integral/GetIntegralTotal", p);
/**
 *  积分规则
 * @param {}
 */
export const apiRules = p => api.post("integral/ruleSettingGetList", p);
/**
 *  积分记录
 * @param {}
 */
export const apiIntegralRecord = p => api.post("integral/ruleRecordList", p);

/**
 *  我的邀请码
 * @param {}
 */
export const apiMyInvite = p => api.post("integral/getInviteCode", p);

/**
 *  查询个人信息
 * @param {}
 */
export const apiGetUserinfo = p => api.post("my/myInfo/get", p);

/**
 *  更新个人信息
 * @param {}
 */
export const apiUpdateUserinfo = p => api.post("my/myInfo/update", p);
